import { FC } from "react";
import { ProposalRoom } from "../../app/types/ProposalTypes";

interface RoomReciptProps {
  room: ProposalRoom;
  locale: string;
}

const RoomRecipt: FC<RoomReciptProps> = ({ room, locale }) => {
  return (
    <tr className="text-[18px] font-normal border-b border-gray-100">
      <td className="py-2 pr-4">
        <div>{room.name[locale]}</div>
        {room.description[locale] && (
          <div className="text-[14px] text-gray-400">{room.description[locale]}</div>
        )}
      </td>
      <td className="py-2 pr-4 text-right">
        {room.start_time}–{room.end_time}
      </td>
      <td className="py-2 text-right">{room.price},-</td>
    </tr>
  );
};

export default RoomRecipt;
